export const required = value => {
    if (value === '') {
        return 1;
    }
    return 0;
};

export const length = (value, start, end) => {
    let errCount = 0;

    if (value.length < start) {
        errCount++;
    }
    if (value.length > end) {
        errCount++;
    }
    return errCount;
};

export const alphanumeric = value => {
    const regExpAlphanumeric = /^[a-zA-Z0-9]+$/;

    if (value !== '') {
        if (!regExpAlphanumeric.test(value)) {
            return 1;
        }
    }
    return 0;
};

export const alphanumericWithSpaces = value => {
    const regExpAlphanumeric = /^[a-zA-Z0-9\s]+$/;

    if (value !== '') {
        if (!regExpAlphanumeric.test(value)) {
            return 1;
        }
    }
    return 0;
};

export const password = value => {
    //const regExpAlphanumeric = /^[a-zA-Z0-9]+$/;
    const regExpPassword = /^((?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[\W|\/_]).{8,50})$/;

    if (!regExpPassword.test(value)) {
        return 1;
    }
    return 0;
};

export const emailAddress = function(tagVal) {
    //var regExpEmail = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
    let regExpEmail = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (tagVal !== '') {
        if (!regExpEmail.test(tagVal)) {
            return 1;
        }
    }
    return 0;
};

// 	numericonly = function (tagId, validMessageId) {
// 		var tagVal = $('#' + tagId).val();
// 		var currentMessage = $('#' + validMessageId).text();
// 		var regExpAlphanumeric = /^[0-9]+$/;
//
// 		if (tagVal != "") {
// 			if (!regExpAlphanumeric.test(tagVal)) {
// 				$('#' + validMessageId).text(concatenateMessage(currentMessage, "only whole numbers accepted"));
// 				$('#' + tagId).focus();
// 				return 1;
// 			}
// 		}
//
// 		return 0;
// 	},
// 	numericBetween = function (tagId, validMessageId, min, max) {
// 		var tagVal = $('#' + tagId).val();
// 		var currentMessage = $('#' + validMessageId).text();
//
// 		if (tagVal != "") {
//
// 			if (tagVal < min){
// 				$('#' + validMessageId).text(concatenateMessage(currentMessage, "can only be a number between " + min + " and " + max));
// 				$('#' + tagId).focus();
// 				return 1
//
// 			}
//
// 			if (tagVal > max){
// 				$('#' + validMessageId).text(concatenateMessage(currentMessage, "can only be a number between " + min + " and " + max));
// 				$('#' + tagId).focus();
// 				return 1
//
// 			}
//
//
//
// 		}
//
// 		return 0;
// 	},
//

// 	alphabet = function (tagId, validMessageId, allowedSpaces) {
// 		var tagVal = $('#' + tagId).val();
// 		var currentMessage = $('#' + validMessageId).text();
//
// 		if (allowedSpaces) {
// 			var regExpAlpha = /^[a-zA-Z\s]+$/;
// 		}
// 		else {
// 			var regExpAlpha = /^[a-zA-Z]+$/;
// 		}
//
// 		if (tagVal != "") {
// 			if (!regExpAlpha.test(tagVal)) {
// 				$('#' + validMessageId).text(concatenateMessage(currentMessage, "may only be letters"));
// 				$('#' + tagId).focus();
// 				return 1;
// 			}
// 		}
// 		return 0;
// 	},
// 	telephone = function (tagId, validMessageId) {
// 		var tagVal = $('#' + tagId).val();
// 		var currentMessage = $('#' + validMessageId).text();
// 		var regExpPhone = new RegExp("^[0-9()+ -]{8,35}$");
//
// 		//console.log("telephone: regExpPhone", regExpPhone);
// 		if (tagVal != "") {
// 			if (!regExpPhone.test(tagVal)) {
// 				$('#' + validMessageId).text(concatenateMessage(currentMessage, "invalid telephone number"));
// 				$('#' + tagId).focus();
// 				return 1;
// 			}
// 		}
// 		return 0;
// 	},
// 	internationalPhone = function (tagId, validMessageId) {
// 		var tagVal = $('#' + tagId).val();
// 		var currentMessage = $('#' + validMessageId).text();
// 		var regExpPhone = new RegExp("^[(0-9()+ ]{8,35}$");
//
// 		if (tagVal != "") {
// 			if ((tagVal.length < 11) || (!regExpPhone.test(tagVal))) {
// 				$('#' + validMessageId).text(concatenateMessage(currentMessage, "invalid number, try including the country code, eg. +61 (0)3 9685 4625"));
// 				$('#' + tagId).focus();
// 				return 1;
// 			}
// 		}
// 		return 0;
// 	},
// 	email = function (tagId, validMessageId) {
// 		var tagVal = $('#' + tagId).val();
// 		var currentMessage = $('#' + validMessageId).text();
// 		var regExpEmail = /^([\w-\.]+@([\w-]+\.)+[\w-]{2,4})?$/;
//
// 		if (tagVal != "") {
// 			if (!regExpEmail.test(tagVal)) {
// 				$('#' + validMessageId).text(concatenateMessage(currentMessage, "must be in a valid email format"));
// 				$('#' + tagId).focus();
// 				return 1;
// 			}
// 		}
// 		return 0;
// 	},



// WEBPACK FOOTER //
// ./src/helpers/formValidation.js